import gsap from 'gsap';
import { fadeFromTo, fadeTo } from '../fade/fade';
import { revealLines } from '../reveal/reveal';
import { slideUp, slideUpFadeIn } from '../slide/slide';
import {
  splitCharsSlideIn,
  splitCharsSlideOut,
  splitElement,
  splitLineKaraoke,
  splitLineRotateIn,
  splitRotateX3dIn,
} from '../split/split';
import type { TextTransitionType } from './text.types';

export function textTransition(
  element: HTMLElement,
  type: TextTransitionType | undefined,
): gsap.core.Timeline {
  const timeline = gsap.timeline();
  let transition;

  switch (type) {
    case 'splitCharsSlideOutDown':
      transition = splitCharsSlideOut(element);
      break;
    case 'splitCharsSlideOutUp':
      transition = splitCharsSlideOut(element, {
        y: '-100%',
      });
      break;
    case 'splitCharsSlideInUp':
      transition = splitCharsSlideIn(element);
      break;
    case 'splitCharsWordsRichText':
      transition = splitLineRotateIn(element);
      // transition = splitCharsSlideIn(element, { splitType: 'words', addInnerChild: false }));
      break;
    case 'splitCharsSlideInDown':
      transition = splitCharsSlideIn(element, {
        y: '-100%',
      });
      break;
    case 'splitLineRotateIn_splitChars':
      transition = splitLineRotateIn(element);
      break;
    case 'splitLineRotateIn':
      transition = splitLineRotateIn(element);
      break;
    case 'splitLineRotateInRichText':
      transition = splitLineRotateIn(element);
      break;
    case 'splitWordsSlideOutUp':
      transition = splitCharsSlideOut(element, {
        y: '-100%',
        splitType: 'words',
      });
      break;
    case 'splitWordsSlideInUp':
      transition = splitCharsSlideIn(element, {
        splitType: 'words',
        minStaggerDuration: 0.035,
        maxStaggerDuration: 0.5,
      });
      break;
    case 'splitLineKaraoke':
      transition = splitLineKaraoke(element);
      break;
    case 'fadeOut':
      transition = fadeTo(element, { duration: 0.3 });
      break;
    case 'fadeIn':
      transition = fadeFromTo(element);
      break;
    case 'slideUpFadeIn':
      transition = slideUpFadeIn(element);
      break;
    case 'slideUp':
      transition = slideUp(element);
      break;
    case 'splitRotateX3dIn':
      transition = splitRotateX3dIn(element);
      break;
    case 'revealLinesIn':
      transition = revealLines(element, { from: 'left' });
      break;
    case 'revealLinesInOut':
      transition = revealLines(element, { from: 'left', type: 'inOut', clearProps: '' });
      break;
    case 'splitCharsNone': {
      // This is added since we needed to page-transition from the same component to another component,
      // where the previous-component had a chars-animation and the new component needs to do nothing but replace the old component.
      // So this is to avoid a jump going from 'splitted-text' to 'non-splitted-text'. (different letter-spacing when split vs non-split).
      splitElement(
        element,
        'chars',
        {
          linesClass: 'mask-split-line',
        },
        true,
      );

      break;
    }
    case 'none':
      break;
    default:
      transition = splitLineRotateIn(element);
  }

  if (transition) timeline.add(transition);

  return timeline;
}
